import { Link } from 'react-router-dom';
import { useLanguage } from '../../shell/language-context';

// 404 within the SPA (client-side routing). Offers a way back to the overview.
export function NotFoundScreen() {
  const { t } = useLanguage();
  return (
    <div style={{ textAlign: 'center', padding: '48px 20px' }}>
      <div style={{ fontSize: '2.4rem', fontWeight: 800, letterSpacing: '-1px' }}>404</div>
      <p className="muted" style={{ margin: '6px 0 20px' }}>
        {t('common.error_body')}
      </p>
      <Link className="btn" to="/">
        {t('admin.nav.overview')}
      </Link>
    </div>
  );
}
